import React from 'react'
// hooks
import { useSessionManager } from './useSessionManager'
// utils
import { authChannel } from './utils'

const SessionProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  useSessionManager(authChannel)

  return <>{children}</>
}

export default SessionProvider
